/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubscriptionInfoFromJSON, SubscriptionInfoToJSON } from './SubscriptionInfo';
/**
 * Check if a given object implements the QuotaResponse interface.
 */
export function instanceOfQuotaResponse(value) {
    if (!('limit' in value) || value['limit'] === undefined)
        return false;
    if (!('periodEnd' in value) || value['periodEnd'] === undefined)
        return false;
    if (!('remaining' in value) || value['remaining'] === undefined)
        return false;
    if (!('subscription' in value) || value['subscription'] === undefined)
        return false;
    if (!('used' in value) || value['used'] === undefined)
        return false;
    return true;
}
export function QuotaResponseFromJSON(json) {
    return QuotaResponseFromJSONTyped(json, false);
}
export function QuotaResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        ...json,
        'balance': json['balance'] == null ? undefined : json['balance'],
        'limit': json['limit'],
        'periodEnd': json['period_end'],
        'remaining': json['remaining'],
        'resetDate': json['reset_date'] == null ? undefined : json['reset_date'],
        'subscription': SubscriptionInfoFromJSON(json['subscription']),
        'used': json['used'],
    };
}
export function QuotaResponseToJSON(json) {
    return QuotaResponseToJSONTyped(json, false);
}
export function QuotaResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        ...value,
        'balance': value['balance'],
        'limit': value['limit'],
        'period_end': value['periodEnd'],
        'remaining': value['remaining'],
        'reset_date': value['resetDate'],
        'subscription': SubscriptionInfoToJSON(value['subscription']),
        'used': value['used'],
    };
}
